/**
 * =====================================
 * File: Home.js
 * Page: /
 * Purpose: Creates the splash page that greets users on
 *  first page access
 * Author: Noah Fultz
 * Date: 2026-06-13
 * =====================================
 */

import { useState, useEffect } from 'react';
import './Home.css'

import { PageCard, BlockButton } from '../../components';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function Home({ access_level = 'Public' }) {
	// Stores image display information
	const [imgURL, setImgURL] = useState(null);
	const [altText, setAltText] = useState(null);

	// Stores the body text of the main page
	const [mainText, setMainText] = useState(null);

	useEffect(() => {
		// On mount, store the page display information
		const loadImage = async () => {
			// Store the image in memory and create a URL for displaying
			const img_res = await fetch(`${API_URL}/photos/featured/splash/0`);
			const img_blob = await img_res.blob();
			setImgURL(URL.createObjectURL(img_blob));

			// Store the image metadata to gather alt text
			const meta_res = await fetch(`${API_URL}/photos/featured/splash`);
			const img_meta = await meta_res.json();
			setAltText(img_meta[0].alt_text);

			// Store the text content of the homepage
			const text_res = await fetch(`${API_URL}/pagetext/splash/main`);
			const text_set = await text_res.json();
			setMainText(text_set.body);
		}

		loadImage();
	}, []);


	return (
		<PageCard>
			<div id='home-main-imgctr'>
				{(imgURL && altText) && <img src={imgURL} alt={altText} />}
			</div>

			<div id='home-main-textctr'>
				<h1 id='home-main-header'>Welcome&nbsp;to Troop&nbsp;312!</h1>

				{mainText &&
					<p id='home-main-bodytext'
					dangerouslySetInnerHTML={{
							__html: mainText
								.replaceAll(/<em\s*[^/]*>/g, `<em class='publicpage-em'>`)
								.replaceAll(/<a\s*/g, `<a class='publicpage-a' `)
						 }}
					/>}

				<BlockButton type='internal' to='/join' width='150px'>Join Us!</BlockButton>
			</div>
		</PageCard>
	);
}


export default Home;